import React, { useState } from 'react';
import { ToggleButtonGroup, ToggleButton } from 'react-bootstrap';
import GAEventTracking from '@components/tracking/GAEventTracking';

function ThemeSettings() {
  const [radioValue, setRadioValue] = useState(false);
  const gaEventTracker = GAEventTracking('Settings');

  const changeTheme = () => {
    if (document.body.classList.contains('mod-skin-dark')) {
      document.body.classList.add('mod-skin-light');
      document.body.classList.remove('mod-skin-dark');
      localStorage.setItem('theme', 'light');
      gaEventTracker('Change Theme', 'Theme Light Mode');
    } else {
      document.body.classList.add('mod-skin-dark');
      document.body.classList.remove('mod-skin-light');
      localStorage.setItem('theme', 'dark');
      gaEventTracker('Change Theme', 'Theme Dark Mode');
    }
  };
  const lightStyle = {
    '--fa-primary-color': 'var(--theme-secondary)',
    '--fa-secondary-color': 'var(--lightBackground-2)',
    '--fa-primary-opacity': 1,
    '--fa-secondary-opacity': 1,
  };
  const darkStyle = {
    '--fa-primary-color': 'var(--darkBackground-3)',
    '--fa-secondary-color': 'var(--darkBackground-1)',
    '--fa-primary-opacity': 1,
    '--fa-secondary-opacity': 1,
  };
  return (
    <>
      <h5>Theme</h5>
      <div className="list mt-1">
        <ToggleButtonGroup
          name="radios"
          type="radio"
          size="sm"
          onChange={changeTheme}
        >
          <ToggleButton
            name="radio"
            size="sm"
            title="Light"
            className={document.body.classList.contains('mod-skin-light') ? 'btn-default waves-effect waves-themed active' : 'btn-default waves-effect waves-themed'}
            value="light"
            checked={radioValue === 'light' || document.body.classList.contains('mod-skin-light')}
            onChange={e => {
              setRadioValue(e.currentTarget.value);
            }}
          >
            <i className="fad fa-browser fa-7x" style={lightStyle} />
          </ToggleButton>
          <ToggleButton
            name="radio"
            size="sm"
            title="Dark"
            className={document.body.classList.contains('mod-skin-dark') ? 'btn-default waves-effect waves-themed active' : 'btn-default waves-effect waves-themed'}
            value="dark"
            checked={radioValue === 'dark' || document.body.classList.contains('mod-skin-dark')}
            onChange={e => {
              setRadioValue(e.currentTarget.value);
            }}
          >
            <i className="fad fa-browser fa-7x" style={darkStyle} />
          </ToggleButton>
        </ToggleButtonGroup>
      </div>
    </>
  );
}

export default ThemeSettings;
